export const cn = (...args) => [...args].filter(Boolean).join(' ');
